export const MAX_INVENTORY_QUANTITY_TO_SET = 500;
